import { useState } from "react";
import { Comment } from "./CommentList/CommentList";

const useCommentActions = (
  onAdd?: (comment: string) => Promise<boolean>,
  onDelete?: (comment: Comment) => Promise<boolean>,
) => {
  const [chosenComment, setChosenComment] = useState<Comment>();
  const [createVisible, setCreateVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);

  const handleAdd = async (comment: string) => {
    const success = await onAdd?.(comment);

    if (success) setCreateVisible(false);
  };

  const handleDeleteClicked = (comment: Comment) => {
    setChosenComment(comment);
    setDeleteVisible(true);
  };

  const handleDelete = async () => {
    if (!chosenComment) return;

    const success = await onDelete?.(chosenComment);

    if (success) {
      setDeleteVisible(false);
      setChosenComment(undefined);
    }
  };

  return {
    createVisible,
    setCreateVisible,
    deleteVisible,
    setDeleteVisible,
    handleAdd,
    handleDeleteClicked,
    handleDelete,
  };
};

export default useCommentActions;
